export default __webpack_public_path__ + "static/slide-02-8dbcb76ad6fcf86fa5a33989c08eb367.jpg";